import { render } from "./KeyFocus.vue?vue&type=template&id=72b954d6&scoped=true"
import script from "./KeyFocus.vue?vue&type=script&lang=js"
export * from "./KeyFocus.vue?vue&type=script&lang=js"

import "./KeyFocus.vue?vue&type=style&index=0&id=72b954d6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Jude\\Desktop\\projects\\creditclan\\clan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b954d6"]])

export default __exports__